import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { NovaExpression } from "@/components/nova/kit";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const isDestructive = props.variant === "destructive";
        return (
          // GOOGIE-SURFACE-1 — see sonner.tsx: `g-toast` is the one
          // hook googie.css repaints both toasters through, and
          // `destructive` carries the hue for the error card.
          <Toast key={id} className={isDestructive ? "g-toast destructive" : "g-toast"} {...props}>
            {isDestructive ? (
              // Error card — Nova fronts the message instead of a red
              // banner. She reacts (shocked) while the copy stays calm;
              // the ember accent lives on the card's left edge + a soft
              // halo behind her. Title/description keep their Radix
              // roles so screen readers announce exactly as before.
              <div className="flex items-center gap-3.5">
                <div className="relative shrink-0" aria-hidden="true">
                  <div className="absolute -inset-2 rounded-full bg-destructive/25 blur-xl" />
                  <NovaExpression id="shocked" size={52} pop={false} className="relative" />
                </div>
                <div className="grid gap-1">
                  {title && <ToastTitle>{title}</ToastTitle>}
                  {description && <ToastDescription>{description}</ToastDescription>}
                </div>
              </div>
            ) : (
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            )}
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
